import type { IconNode as IconNodeType } from 'lucide-react'
import { __iconNode as boxes } from 'lucide-react/icons/boxes'
import { __iconNode as calendarNode } from 'lucide-react/icons/calendar'
import { __iconNode as carNode } from 'lucide-react/icons/car'
import { __iconNode as carFrontNode } from 'lucide-react/icons/car-front'
import { __iconNode as check } from 'lucide-react/icons/check'
import { __iconNode as chevronDownNode } from 'lucide-react/icons/chevron-down'
import { __iconNode as chevronRightNode } from 'lucide-react/icons/chevron-right'
import { __iconNode as chevronUpNode } from 'lucide-react/icons/chevron-up'
import { __iconNode as circleNode } from 'lucide-react/icons/circle'
import { __iconNode as pauseCircleNode } from 'lucide-react/icons/circle-pause'
import { __iconNode as circleSlash2Node } from 'lucide-react/icons/circle-slash-2'
import { __iconNode as userNode } from 'lucide-react/icons/circle-user'
import { __iconNode as coffeeNode } from 'lucide-react/icons/coffee'
import { __iconNode as croissantNode } from 'lucide-react/icons/croissant'
import { __iconNode as fileNode } from 'lucide-react/icons/file'
import { __iconNode as filePenNode } from 'lucide-react/icons/file-pen'
import { __iconNode as folderNode } from 'lucide-react/icons/folder'
import { __iconNode as folderPenNode } from 'lucide-react/icons/folder-pen'
import { __iconNode as globeNode } from 'lucide-react/icons/globe'
import { __iconNode as headphoneOffNode } from 'lucide-react/icons/headphone-off'
import { __iconNode as headphonesNode } from 'lucide-react/icons/headphones'
import { __iconNode as houseNode } from 'lucide-react/icons/house'
import { __iconNode as image } from 'lucide-react/icons/image'
import { __iconNode as lightbulbNode } from 'lucide-react/icons/lightbulb'
import { __iconNode as loaderCircle } from 'lucide-react/icons/loader-circle'
import { __iconNode as mailNode } from 'lucide-react/icons/mail'
import { __iconNode as mailCheckNode } from 'lucide-react/icons/mail-check'
import { __iconNode as mailOpenNode } from 'lucide-react/icons/mail-open'
import { __iconNode as mailPlusNode } from 'lucide-react/icons/mail-plus'
import { __iconNode as monitorNode } from 'lucide-react/icons/monitor'
import { __iconNode as monitorOffNode } from 'lucide-react/icons/monitor-off'
import { __iconNode as pencilNode } from 'lucide-react/icons/pencil'
import { __iconNode as phoneNode } from 'lucide-react/icons/phone'
import { __iconNode as phoneCallNode } from 'lucide-react/icons/phone-call'
import { __iconNode as phoneForwardedNode } from 'lucide-react/icons/phone-forwarded'
import { __iconNode as phoneIncomingNode } from 'lucide-react/icons/phone-incoming'
import { __iconNode as phoneOffNode } from 'lucide-react/icons/phone-off'
import { __iconNode as phoneOutgoingNode } from 'lucide-react/icons/phone-outgoing'
import { __iconNode as powerNode } from 'lucide-react/icons/power'
import { __iconNode as rocketNode } from 'lucide-react/icons/rocket'
import { __iconNode as save } from 'lucide-react/icons/save'
import { __iconNode as searchNode } from 'lucide-react/icons/search'
import { __iconNode as shieldUser } from 'lucide-react/icons/shield-user'
import { __iconNode as trash } from 'lucide-react/icons/trash-2'
import { __iconNode as undo } from 'lucide-react/icons/undo'
import { __iconNode as userRoundPenNode } from 'lucide-react/icons/user-round-pen'
import { __iconNode as utensilsNode } from 'lucide-react/icons/utensils'
import { __iconNode as ipdEmpty } from './custom-icons/ipd-empty'
import { __iconNode as ipdPhoneRingingNode } from './custom-icons/ipd-phone-ringing'

export const iconNodes = [
	{ iconNode: pauseCircleNode, name: 'pause' as const },
	{ iconNode: coffeeNode, name: 'coffee' as const },
	{ iconNode: croissantNode, name: 'croissant' as const },
	{ iconNode: utensilsNode, name: 'utensils' as const },
	{ iconNode: globeNode, name: 'globe' as const },
	{ iconNode: houseNode, name: 'house' as const },
	{ iconNode: searchNode, name: 'search' as const },
	{ iconNode: chevronRightNode, name: 'chevronRight' as const },
	{ iconNode: chevronDownNode, name: 'chevronDown' as const },
	{ iconNode: chevronUpNode, name: 'chevronUp' as const },
	{ iconNode: headphoneOffNode, name: 'headphone-off' as const },
	{ iconNode: monitorOffNode, name: 'monitor-off' as const },
	{ iconNode: phoneOffNode, name: 'phone-off' as const },
	{ iconNode: lightbulbNode, name: 'lightbulb' as const },
	{ iconNode: powerNode, name: 'power' as const },
	{ iconNode: circleNode, name: 'circle' as const },
	{ iconNode: circleSlash2Node, name: 'circle-slash' as const },
	{ iconNode: headphonesNode, name: 'headphones' as const },
	{ iconNode: monitorNode, name: 'monitor' as const },
	{ iconNode: phoneNode, name: 'phone' as const },
	{ iconNode: phoneCallNode, name: 'phone-call' as const },
	{ iconNode: phoneForwardedNode, name: 'phone-forwarded' as const },
	{ iconNode: phoneIncomingNode, name: 'phone-incoming' as const },
	{ iconNode: phoneOutgoingNode, name: 'phone-outgoing' as const },
	{ iconNode: fileNode, name: 'file' as const },
	{ iconNode: filePenNode, name: 'file-pen' as const },
	{ iconNode: folderNode, name: 'folder' as const },
	{ iconNode: folderPenNode, name: 'folder-pen' as const },
	{ iconNode: rocketNode, name: 'rocket' as const },
	{ iconNode: pencilNode, name: 'pencil' as const },
	{ iconNode: userRoundPenNode, name: 'user-pen' as const },
	{ iconNode: mailNode, name: 'mail' as const },
	{ iconNode: mailOpenNode, name: 'mail-open' as const },
	{ iconNode: mailPlusNode, name: 'mail-plus' as const },
	{ iconNode: mailCheckNode, name: 'mail-check' as const },
	{ iconNode: calendarNode, name: 'calendar' as const },
	{ iconNode: carNode, name: 'car' as const },
	{ iconNode: carFrontNode, name: 'car-front' as const },
	{ iconNode: userNode, name: 'user' as const },
	{ iconNode: ipdPhoneRingingNode, name: 'phone-ringing' as const },
	{ iconNode: ipdEmpty, name: 'empty' as const },

	{ iconNode: loaderCircle, name: 'loader' as const },
	{ iconNode: trash, name: 'trash' as const },
	{ iconNode: save, name: 'save' as const },
	{ iconNode: undo, name: 'undo' as const },
	{ iconNode: image, name: 'image' as const },
	{ iconNode: boxes, name: 'boxes' as const },
	{ iconNode: shieldUser, name: 'shieldUser' as const },
	{ iconNode: check, name: 'check' as const },
]

export type IconNodeName = (typeof iconNodes)[number]['name']

export type IconNode = { iconNode: IconNodeType; name: IconNodeName }
export type IconTuple = [IconNodeName, IconNodeType]
export const iconNodeNames = iconNodes.map((icon) => icon.name)

export function getIconNodeByName(
	name: IconNodeName,
): IconNodeType | undefined {
	const icon = iconNodes.find((icon) => icon.name === name)
	if (!icon) {
		// console.warn(`Icon "${name}" not found in iconNodes.`)
		return undefined
	}
	return icon.iconNode
}

export default iconNodes.map(({ name, iconNode }) => [
	name,
	iconNode,
]) as IconTuple[]

export function filterIconsByNames(...names: IconNodeName[]): IconTuple[] {
	return iconNodes
		.filter(({ name }) => names.includes(name))
		.map(({ name, iconNode }) => [name, iconNode]) as IconTuple[]
}

export type { IconNode as IconNodeType } from 'lucide-react'
